{
  "version": 1,
  "asset_id": "18f53e0e-1ea6-439e-a68a-7b9e695fcef0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/18f53e0e-1ea6-439e-a68a-7b9e695fcef0/lap-band-removed-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/18f53e0e-1ea6-439e-a68a-7b9e695fcef0/lap-band-removed-800.webp",
  "original_filename": "lap-band-removed-800.webp",
  "size": 52542,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:12:03Z"
}
